import { StyleObject } from 'styletron-react';

export const filterContainer: StyleObject = {
	display: 'flex',
	width: '100%',
	justifyContent: 'left',
	margin: 'auto',
	background: 'white'
};
export const filterItem: StyleObject = {
	width: '230px !important',
	textAlign: 'center',
	padding: '10px 10px'
};
export const filterItemLabel: StyleObject = {
	color: 'red'
};
export const filterItemButton: StyleObject = {
	textAlign: 'center',
	padding: '32px 10px'
};
export const listContainer: StyleObject = {
	height: '60px',
	display: 'flex',
	alignItems: 'center',
	backgroundColor: 'white',
	paddingLeft: '10px',
	borderTop: '1px solid rgb(242, 242, 242)',
	gap: '20px'
};
export const listItemButton: StyleObject = { padding: '6px 6px' };
